// extracted by mini-css-extract-plugin
module.exports = {"outerContainer":"ContactInformation_outerContainer__cnPcw","innerContainer":"ContactInformation_innerContainer__uBk8R","card":"ContactInformation_card__F_MRE"};